import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdvancedTrainingMethodsPage } from './advanced-training-methods-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdvancedTrainingMethodsPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdvancedTrainingMethodsPage]
})
export class AdvancedTrainingMethodsPageModule { }
